/**
 * 悬浮钮共享滚动状态机（首页货篮钮 / 全局货篮钮 / 智能助手 FAB 同款——兄弟控件同一套行为）
 *
 * 状态：VISIBLE（常态）⇄ PEEK（向下滚：半透明 + 向所在边缘收，仍留约 45% 可见，入口不消失）。
 * 复原路径（同一套，无第二套 timeout）：向上滚 / 停止滚动 400ms / 点击按钮 / 离开页面。
 * 常量沿用既有货篮实现口径：阈值 200px、idle 400ms（原 Home.handleScroll / CartFloatEntry.onScroll）。
 *
 * 用法（两种宿主形态）：
 *   1) 宿主自己已监听 scroll（如 Home.handleScroll）：滚动回调里直接 this.updateFloatPeek(scrollTop)，
 *      不加第二条监听；
 *   2) App 级独立组件：可见时 this.bindFloatScroll()、隐藏/销毁时 this.unbindFloatScroll()
 *      （unbind 顺带清态——回到页面必为 VISIBLE，不把 PEEK 状态带回来）。
 * 宿主须提供组件选项 floatBtnRef（按钮 ref 名，进 PEEK 时按其位置判定向哪边收）。
 * 点击复原：宿主 click handler 里调 this.resetFloatPeek()。
 * PEEK 视觉统一在 App.vue 全局样式 .float-fab（opacity/transform/transition 单一来源）。
 */
const PEEK_THRESHOLD_PX = 200
const PEEK_IDLE_MS = 400

export default {
  data () {
    return {
      floatPeek: false, // PEEK 态（向下滚动中）
      floatPeekSide: 1 // 1=向右缘收 / -1=向左缘收（钮在左半屏时翻向）
    }
  },
  methods: {
    updateFloatPeek (scrollTop) {
      // 初次滚动前基线视作 0（对齐旧实现 _lastScrollTop: 0 的 data 初始化语义——
      // 否则 st > undefined 恒 false，页面首次下滚永远不进 PEEK）
      const lastY = Number.isFinite(this.$_floatLastY) ? this.$_floatLastY : 0
      const goingDown = scrollTop > PEEK_THRESHOLD_PX && scrollTop > lastY
      this.$_floatLastY = scrollTop
      if (goingDown && !this.floatPeek) {
        // 进 PEEK 定方向：按按钮当前位置靠哪边收（未拖拽时默认右缘）。
        // floatBtnRef 是自定义组件选项——Vue 2 只把它并进 $options，不代理到 this；
        // 此前读 this.floatBtnRef 恒 undefined → 方向探测整体被跳过 → floatPeekSide
        // 恒为初始值 1（右）：拖到左边的钮一上滑也向右收。必须走 this.$options 取。
        const refName = this.$options.floatBtnRef
        const btn = refName ? this.$refs[refName] : null
        if (btn) {
          const r = btn.getBoundingClientRect()
          this.floatPeekSide = (r.left + r.width / 2) < window.innerWidth / 2 ? -1 : 1
        }
      }
      this.floatPeek = goingDown
      clearTimeout(this.$_floatIdleTimer)
      this.$_floatIdleTimer = setTimeout(() => { this.floatPeek = false }, PEEK_IDLE_MS)
    },
    // 点击/触摸即复原
    resetFloatPeek () {
      clearTimeout(this.$_floatIdleTimer)
      this.floatPeek = false
    },
    bindFloatScroll () {
      if (this.$_floatBound) return
      this.$_floatOnScroll = () => {
        const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        this.updateFloatPeek(st)
      }
      window.addEventListener('scroll', this.$_floatOnScroll, { passive: true })
      this.$_floatBound = true
      // 绑定时基线对齐当前滚动位置（清掉跨页残留的旧基线，回页后第一次下滚即可进 PEEK）
      this.$_floatLastY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    unbindFloatScroll () {
      if (!this.$_floatBound) return
      window.removeEventListener('scroll', this.$_floatOnScroll)
      this.$_floatBound = false
      this.resetFloatPeek() // 离开页面即清态：回来必为 VISIBLE
    }
  },
  beforeDestroy () {
    this.unbindFloatScroll()
  }
}
